const zhCN = {
  common: {
    language: '语言',
    chinese: '中文',
    english: 'English',
    navMenu: '网站导航',
    home: '主页',
    send: '发送',
    viewMore: '查看更多',
    viewDetails: '查看详情',
    contactNow: '立即咨询',
    backToList: '返回招聘列表',
    notFound: '未找到该职位信息',
    publishDate: '发布日期：{date}',
    locationPending: '工作地点：待定',
    salaryNegotiable: '薪资面议',
    langShortCN: 'CN',
    langShortEN: 'EN',
    switchToDarkNav: '切换为深色导航',
    switchToLightNav: '切换为浅色导航'
  },
  header: {
    companyName: '浙江直列动力有限公司',
    companyNameEn: 'Zhejiang In-Line PowerCo.,Ltd.',
    openMenu: '打开导航菜单'
  },
  home: {
    service: {
      title: '直列动力',
      subtitle: '引领航空发动机技术创新，推动低空经济发展',
      founded: '成立时间',
      research: '科研人员',
      patents: '发明专利',
      yearUnit: '/年',
      personUnit: '/人',
      itemUnit: '/项',
      testUnit: '/航时',
      testTitle: 'TBO可靠性试验'
    },
    solution: {
      title: '产品中心',
      subtitle: '优异的稳定性与高效性能，灵活多样，提供全方位技术支持与解决方案。'
    },
    news: {
      title: '新闻资讯',
      subtitle: '捕捉最新动态，深度解析行业趋势，引领科技发展新风向。',
      featureTitle: '【国产航空动力逆袭！】浙江直列动力ZL-200-01发动机...',
      featureContent:
        '2025年12月，浙江桐庐传出重磅消息：浙江直列动力自主研发的ZL-200-01四缸航空活塞发动机完成适航验证，即将进入量产阶段。这款功率达130kW、重量仅57KG、油耗低至5.9L/小时的"中国心"，不仅打破了国外品牌对通用航空动力系统的垄断，更以30%的价格优势和98%的国产化率，让中国低空经济产业迎来"换心"时刻！'
    }
  },
  footer: {
    contact: '联系方式',
    contactText: '邮箱：jack@zfuch.com                           地址：浙江省桐庐县经济开发区马家路398号英飞特产业化园区2期一号楼二楼201室',
    companyName: '浙江直列动力有限公司',
    companyIcp: '浙江直列动力有限公司浙ICP备2025192580号',
    socialAria: '社交媒体账号',
    kuaishou: '快手账号',
    wechat: '微信公众号',
    kuaishouQrAlt: '快手账号二维码',
    wechatQrAlt: '微信公众号二维码'
  },
  about: {
    title: '关于我们',
    companyProfile: '公司简介',
    contactUs: '联系我们'
  },
  solution: {
    title: '产品中心',
    mes: {
      engine: '动力引擎',
      seriesProduct: '系列产品',
      subtitle: '优异的稳定性与高效性能，灵活多样，提供全方位技术支持与解决方案。',
      breadcrumb: '当前位置：首页 > 产品中心',
      series200: 'ZL-200系列',
      series400: 'ZL-400系列',
      series600: 'ZL-600系列',
      defaultProductTitle: 'ZL-200-01直列四缸活塞发动机',
      singleIgnition: '单次点火高达',
      durability: '耐用性',
      highAltitude: '高空适配性',
      turnUnit: '转',
      hourUnit: '小时',
      meterUnit: 'M'
    }
  },
  casePage: {
    title: '新闻动态'
  },
  honor: {
    title: '资质荣誉',
    certificateAlt: '荣誉证书',
    fallbackCertificateTitle: '中国人保资质荣誉'
  },
  recruit: {
    title: '人才招聘',
    typeTitle: '招聘类型',
    social: '社招岗位',
    campus: '校招岗位',
    empty: '暂无招聘信息',
    waiting: '敬请期待',
    detailTitle: '职位详情',
    duty: '岗位职责',
    requirement: '任职资格',
    salary: '薪资待遇',
    remark: '备注'
  },
  dialog: {
    title: '请给我们留言',
    messagePlaceholder: '请在此输入留言内容，我们会尽快与您联系。（必填）',
    namePlaceholder: '请输入您的姓名',
    telPlaceholder: '请输入您的电话',
    emailPlaceholder: '请输入您的邮箱',
    addressPlaceholder: '请输入您的地址',
    validateRequired: '请输入'
  },
  textMap: {
    首页: '首页',
    解决方案: '解决方案',
    产品中心: '产品中心',
    关于我们: '关于我们',
    新闻动态: '新闻动态',
    新闻资讯: '新闻资讯',
    客户案例: '客户案例',
    资质荣誉: '资质荣誉',
    人才招聘: '人才招聘',
    联系我们: '联系我们'
  }
}

const enUS = {
  common: {
    language: 'Language',
    chinese: '中文',
    english: 'English',
    navMenu: 'Site Navigation',
    home: 'Home',
    send: 'Send',
    viewMore: 'View More',
    viewDetails: 'Details',
    contactNow: 'Contact Now',
    backToList: 'Back to Jobs',
    notFound: 'Job not found',
    publishDate: 'Published: {date}',
    locationPending: 'Location: TBD',
    salaryNegotiable: 'Salary negotiable',
    langShortCN: 'CN',
    langShortEN: 'EN',
    switchToDarkNav: 'Use dark navigation bar',
    switchToLightNav: 'Use light navigation bar'
  },
  header: {
    companyName: 'Zhejiang In-Line Power Co., Ltd.',
    companyNameEn: 'Aero Engine Technology Innovator',
    openMenu: 'Open navigation menu'
  },
  home: {
    service: {
      title: 'In-Line Power',
      subtitle: 'Leading aero-engine innovation and enabling low-altitude economy growth',
      founded: 'Founded',
      research: 'R&D Staff',
      patents: 'Patents',
      yearUnit: '/Year',
      personUnit: '/People',
      itemUnit: '/Items',
      testUnit: '/Hours',
      testTitle: 'TBO Reliability Test'
    },
    solution: {
      title: 'Products',
      subtitle: 'Outstanding stability and efficiency with flexible solutions and end-to-end technical support.'
    },
    news: {
      title: 'News',
      subtitle: 'Track the latest updates, decode industry trends, and lead future technology.',
      featureTitle: '[Domestic Aero Power Breakthrough] ZL-200-01 by In-Line Power...',
      featureContent:
        'In December 2025, Tonglu, Zhejiang announced a major milestone: In-Line Power completed airworthiness validation for its self-developed ZL-200-01 four-cylinder aviation piston engine and is entering mass production. With 130kW power, only 57kg weight, and 5.9L/h fuel consumption, this "China Engine" breaks foreign monopoly in general aviation power systems and accelerates the low-altitude economy with strong cost and localization advantages.'
    }
  },
  footer: {
    contact: 'Contact',
    contactText:
      'Email: jack@zfuch.com Address: Room 201, Building 1, Phase II, Inventronics Industrial Park, No.398 Majia Road, Tonglu Economic Development Zone, Zhejiang',
    companyName: 'Zhejiang In-Line Power Co., Ltd.',
    companyIcp: 'Zhejiang ICP No.2025192580',
    socialAria: 'Social media accounts',
    kuaishou: 'Kuaishou',
    wechat: 'WeChat Official Account',
    kuaishouQrAlt: 'Kuaishou QR code',
    wechatQrAlt: 'WeChat account QR code'
  },
  about: {
    title: 'About Us',
    companyProfile: 'Company Profile',
    contactUs: 'Contact Us'
  },
  solution: {
    title: 'Products',
    mes: {
      engine: 'Power Engine',
      seriesProduct: 'Series Products',
      subtitle: 'Outstanding stability and efficiency with flexible solutions and comprehensive technical support.',
      breadcrumb: 'Current Location: Home > Products',
      series200: 'ZL-200 Series',
      series400: 'ZL-400 Series',
      series600: 'ZL-600 Series',
      defaultProductTitle: 'ZL-200-01 Inline Four-Cylinder Piston Engine',
      singleIgnition: 'Single Ignition Up To',
      durability: 'Durability',
      highAltitude: 'High-Altitude Adaptability',
      turnUnit: 'rpm',
      hourUnit: 'hours',
      meterUnit: 'm'
    }
  },
  casePage: {
    title: 'News'
  },
  honor: {
    title: 'Honors & Qualifications',
    certificateAlt: 'Honor Certificate',
    fallbackCertificateTitle: 'PICC Qualification Honor'
  },
  recruit: {
    title: 'Careers',
    typeTitle: 'Recruitment Type',
    social: 'Social Recruitment',
    campus: 'Campus Recruitment',
    empty: 'No openings available',
    waiting: 'Stay tuned',
    detailTitle: 'Job Detail',
    duty: 'Responsibilities',
    requirement: 'Qualifications',
    salary: 'Compensation',
    remark: 'Notes'
  },
  dialog: {
    title: 'Leave us a message',
    messagePlaceholder: 'Please enter your message. We will contact you soon. (Required)',
    namePlaceholder: 'Please enter your name',
    telPlaceholder: 'Please enter your phone number',
    emailPlaceholder: 'Please enter your email',
    addressPlaceholder: 'Please enter your address',
    validateRequired: 'Please enter this field'
  },
  textMap: {
    首页: 'Home',
    解决方案: 'Solutions',
    产品中心: 'Products',
    关于我们: 'About Us',
    新闻动态: 'News',
    新闻资讯: 'News',
    客户案例: 'Cases',
    资质荣誉: 'Honors',
    人才招聘: 'Careers',
    联系我们: 'Contact Us'
  }
}

export default {
  'zh-CN': zhCN,
  'en-US': enUS
}
